import { useContext, useEffect } from 'react'

import CustomizableDashboardContext from '../../../contexts/customizableDashboardContext'

export const shouldRender = (moduleKey, editing, customOptions, loadedModules) => {
  const { moduleProps } = customOptions || {}
  const { hideWhenEmpty } = moduleProps || {}

  const loadedModule = loadedModules.find(m => m.key === moduleKey)

  // Show if:
  // 1. Editing
  // 2. hideWhenEmpty is false
  // 3. hideWhenEmpty is true and we haven't loaded results yet or if we have loaded and have results

  return editing || !hideWhenEmpty || (hideWhenEmpty && (!loadedModule || (loadedModule && loadedModule.hasResults)))
}

function useDashboardModule(moduleKey, options = {}){
  const { loadingPayload } = options || {}
  const { loading, success, result } = loadingPayload || {}

  const customizableDashboardContext = useContext(CustomizableDashboardContext)
  const { callbacks: { moduleLoadComplete } } = customizableDashboardContext

  useEffect(() => {
    if (!loading && success && result){
      moduleLoadComplete({ key: moduleKey, hasResults: !!result.length })
    }
  }, [moduleKey, loading, success, result])

  return {
    moduleKey,
    shouldRender,
  }
}

export default useDashboardModule
